import { useContext } from 'react';

import { LoopContext } from '../context/LoopContext';

export const useLoopContext = () => {
  return useContext(LoopContext);
};
